import {Box, FormControl, InputLabel, MenuItem, Typography} from "@mui/material";
import Select, {SelectChangeEvent} from '@mui/material/Select';
import React, {useState} from "react";
import View from "../../components/View";
import Page from "../../components/Page";
import formulas from "../../services/formulas";

const Heliair = () => {

    const {calcHeliair} = formulas();
    const [ppO2, setPpO2] = useState(1.4);
    const [fO2, setFO2] = useState(32);
    const [fHe, setFHe] = useState(32);
    const [depth, setDepth] = useState(33);
    const [end, setEnd] = useState(33);
    const [targetPresssure, setTargetPressure] = useState(232);

    const changePPO2 = (event: SelectChangeEvent) => {
        const value = parseFloat(event.target.value);
        setPpO2(value)
        const recipe = calcHeliair(end, depth, targetPresssure);
    }

    const changeMix = (event: SelectChangeEvent) => {
        const value = parseInt(event.target.value);
    }

    const calc = (mix: number, ppO2: number): number => {
        const mixInPercent = mix / 100;
        const calculatedMod = ((ppO2 / mixInPercent) - 1) * 10;
        if (Math.round(calculatedMod) === Math.floor(calculatedMod + 0.01)) {
            return Math.round(calculatedMod);
        } else {
            return Math.floor(calculatedMod);
        }
    }

    // @ts-ignore
    return (
        <Page>
            <View>
                <Typography variant="h6" sx={{mt: 1, mb: 1}}>Maximum Operating Depth</Typography>
                <Typography variant="h6"><Box component="span" sx={{border: '1px solid grey', p: 1}}>{depth}</Box> Meters</Typography>
                <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                    <InputLabel id="ppO2">ppO2</InputLabel>
                    <Select
                        labelId="ppO2"
                        id="ppO2"
                        value={ppO2.toString()}
                        label="ppO2"
                        onChange={changePPO2}
                    >
                        <MenuItem key={1.2} value={1.2}>{1.2}</MenuItem>
                        <MenuItem key={1.3} value={1.3}>{1.3}</MenuItem>
                        <MenuItem key={1.4} value={1.4}>{1.4}</MenuItem>
                        <MenuItem key={1.5} value={1.5}>{1.5}</MenuItem>
                        <MenuItem key={1.6} value={1.6}>{1.6}</MenuItem>
                    </Select>
                </FormControl>
                <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                    <InputLabel id="mix">Mix</InputLabel>
                    <Select
                        labelId="mix"
                        id="mix"
                        value={depth.toString()}
                        label="Mix"
                        onChange={changeMix}
                    >
                        {[...Array(100)].map((x, i: number) => (
                            <MenuItem key={x} value={1 + i}>{1 + i}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </View>
            <View>
                <Typography style={{fontWeight: 'bold'}}>Heliair</Typography>
                    <Typography align="left" style={{marginTop: 10}}>
                    Heliair is manufactured by mixing Helium and Air (as the name suggest). It's simple and secure
                    because you don't have to handle pure oxygen.
                </Typography>
                <Typography align="left" sx={{mt:2}}>
                    Heliair can also be topped up time after time and you can analyze the gas with just a Oxygen
                    analyzer
                </Typography>
                <Typography align="left" sx={{mt:2}}>
                    The downside is that Heliair is not very good at great depths due to the END is quite high.
                </Typography>
                <Typography color="#FF0000" align="left" sx={{mt:2}}>
                    Warning! Oxygen lower than 16% is not breathable on the surface and can lead to your death!
                </Typography>
            </View>
        </Page>
    );
}

export default Heliair;